<template>
  <img :src="displayedSrc" :alt="alt" />
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

interface Props {
  src: string
  fallbackSrc: string
  alt?: string
}

const props = withDefaults(defineProps<Props>(), {
  alt: '',
})

const displayedSrc = ref(props.fallbackSrc)

watch(
  () => [props.src, props.fallbackSrc] as const,
  ([src, fallbackSrc], _previousValue, onCleanup) => {
    displayedSrc.value = fallbackSrc

    if (src == fallbackSrc) return

    const image = new Image()
    // Ignore a stale load after the source changes or the component unmounts.
    let active = true

    image.onload = () => {
      if (active) displayedSrc.value = src
    }
    image.src = src

    onCleanup(() => {
      active = false
    })
  },
  { immediate: true }
)
</script>
